import { Outlet } from 'react-router-dom';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';
import { MainContainer } from '@cbridge-modules/layout';
import { UserSettingsSection } from '@cbridge-packages/user-settings';
import { SidebarNavigationDrawer } from '@cbridge-modules/sidebar';
import { useDashboardNavigationItems } from '../navigation/useDashboardNavigationItems';
import { DashboardsSidebarFooter } from './DashboardsSidebarFooter';

export function DashboardsLayout() {
  const dashboardsNavigation = useDashboardNavigationItems();

  return (
    <>
      <SidebarNavigationDrawer
        defaultSidebarCollapsed={false}
        isCollapsible={true}
        settingsKey={UserSettingsSection.Dashboards}
        isResizable={true}
        navigation={dashboardsNavigation}
        navigationBasePath={`/${RouteSegments.Root.Dashboard}`}
        slots={{
          sidebarFooter: DashboardsSidebarFooter,
        }}
      />
      <MainContainer>
        <Outlet />
      </MainContainer>
    </>
  );
}
